export default __webpack_public_path__ + "static/FReg-4x3-S_Quiz-1beb487ba34f67fa4de8c5f5bb2b3611.jpg";